import { render, staticRenderFns } from "./Huntington.vue?vue&type=template&id=21a97c38&scoped=true"
var script = {}
import style0 from "./Huntington.vue?vue&type=style&index=0&id=21a97c38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a97c38",
  null
  
)

export default component.exports